"use client"

import { useRef, useState } from "react";
import Input from "../components/Input";
import Head from "../components/Head";
import Footer from "../components/Footer";
import AlertToast from "../components/AlertToast";

const fields = [
  { name: "user", type: "text", label: "User", placeholder: "Usuario" },
  { name: "password", type: "password", label: "Password", placeholder: "••••••••" },
];

const App = () => {
  const [view, setView] = useState("search");

  const toastRef = useRef(null);
  const showToast = (options) => {
    toastRef.current.showAlert(options);
  };

  const [formData, setFormData] = useState(
    fields.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {})
  );
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  
    // Basic validation for empty fields
    const emptyFields = fields.filter((field) => !formData[field.name]);
    if (emptyFields.length > 0) {
      setError("Please fill in all fields.");
      return;
    }
  
    const { user, password } = formData;
  
    // Validate credentials
    const isValid =
      (user === "imat" && password === "imat*manlab") ||
      (user === "genea" && password === "genea*manlab");
  
    if (!isValid) {
      setError("Usuario o contraseña incorrectos.");
      return;
    }
  
    setError("");
    console.log("Logging in with:", formData);
    setView("checking");
  };

  return (
    <div>
      <Head />
      <AlertToast ref={toastRef} />
      <div className="container mt-5">
        <div className="d-flex justify-content-center"></div>
        {view === "checking" && (
          <Input />
        )}
        {view === "search" && (
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 'calc(100vh - 300px)' }}>
            <div className="w-100" style={{ maxWidth: 360 }}>
              <div className="card shadow-sm p-4 text-center">
                <img
                  src="logo.jpg"
                  alt="Logo"
                  className="mx-auto mb-3"
                  style={{ maxWidth: '360px' }}
                />
                <h5 className="mb-3">Acceso al sistema</h5>
                {error && <div className="alert alert-danger">{error}</div>}
                <form onSubmit={handleSubmit}>
                  {fields.map(f => (
                    <div className="mb-3" key={f.name}>
                      <input
                        type={f.type}
                        name={f.name}
                        placeholder={f.placeholder}
                        value={formData[f.name]}
                        onChange={handleChange}
                        className="form-control"
                      />
                    </div>
                  ))}
                  <button type="submit" className="btn btn-primary w-100">
                    Validar
                  </button>
                </form>
              </div>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default App;
